export const communityMessages = {
  "cs": {
    "community.nav": "Diskuse",
    "community.you": "Vy",
    "community.like": "To se mi líbí",
    "community.unlike": "Odebrat srdce",
    "community.totalReactions": "Reakce: {count}",
    "community.commentPlaceholder": "Přidat komentář…",
    "community.replyPlaceholder": "Napsat odpověď…",
    "community.publicDiscussion": "Veřejná diskuse",
    "community.titlePlaceholder": "Pojmenujte svou diskusi…",
    "community.description": "Místo pro otázky, nápady a společné povídání. Téma může založit každý přihlášený uživatel.",
    "community.new": "Založit diskusi",
    "community.empty": "Zatím tu nejsou žádné diskuse. Začněte první.",
    "community.title": "Název diskuse",
    "community.body": "O čem chcete diskutovat?",
    "community.create": "Zveřejnit diskusi",
    "community.save": "Uložit změny",
    "community.cancel": "Zrušit",
    "community.edit": "Upravit",
    "community.delete": "Smazat",
    "community.deleteDiscussion": "Smazat tuto diskusi včetně komentářů?",
    "community.deleteComment": "Smazat tento komentář? Odpovědi zůstanou zachované.",
    "community.discard": "Zahodit neuložené změny?",
    "community.loading": "Načítání…",
    "community.saving": "Ukládání…",
    "community.error": "Akce se nepodařila. Zkuste to prosím znovu.",
    "community.sessionExpired": "Přihlášení vypršelo. Přihlaste se znovu a zkuste to ještě jednou.",
    "community.forbidden": "K této akci nemáte přístup.",
    "community.notFound": "Tento obsah už není dostupný.",
    "community.invalid": "Zkontrolujte vyplněný text a zkuste to znovu.",
    "community.tooMany": "Příliš mnoho požadavků. Chvíli počkejte a zkuste to znovu.",
    "community.retry": "Zkusit znovu",
    "community.login": "Přihlásit se",
    "community.loginCreate": "Pro založení diskuse se přihlaste.",
    "community.loginComment": "Pro komentování a reakce se přihlaste.",
    "community.loginReact": "Pro přidání reakce se přihlaste.",
    "community.anonymous": "Uživatel",
    "community.comments": "Komentáře",
    "community.commentCount": "Komentáře: {count}",
    "community.noComments": "Zatím bez komentářů.",
    "community.commentLabel": "Napsat komentář",
    "community.sendComment": "Odeslat komentář",
    "community.reply": "Odpovědět",
    "community.replyLabel": "Vaše odpověď",
    "community.sendReply": "Odeslat odpověď",
    "community.replyTo": "Odpověď na komentář od {name}",
    "community.parentComment": "Původní komentář",
    "community.deleted": "Komentář byl smazán.",
    "community.edited": "upraveno",
    "community.moreComments": "Načíst další komentáře",
    "community.reaction": "Reakce",
    "community.addReaction": "Přidat reakci",
    "community.reactionCount": "{emoji}: {count}",
    "community.reactionHint": "Vyberte reakci. Opětovným kliknutím ji odeberete.",
    "community.previous": "Předchozí",
    "community.next": "Další",
    "community.page": "Strana {page}",
    "community.pagination": "Stránkování diskusí",
    "community.back": "Zpět na diskuse",
    "community.open": "Otevřít diskusi",
    "community.emptyPage": "Na této stránce nejsou žádné diskuse.",
    "community.closeComments": "Skrýt komentáře",
    "community.emoji.👍": "To se mi líbí",
    "community.emoji.❤️": "Srdce",
    "community.emoji.😂": "Smích",
    "community.emoji.🎉": "Oslava",
    "community.emoji.😮": "Překvapení",
    "community.emoji.🙏": "Díky"
  },
  "en": {
    "community.nav": "Discussions",
    "community.you": "You",
    "community.like": "Like",
    "community.unlike": "Remove heart",
    "community.totalReactions": "Reactions: {count}",
    "community.commentPlaceholder": "Add a comment…",
    "community.replyPlaceholder": "Write a reply…",
    "community.publicDiscussion": "Public discussion",
    "community.titlePlaceholder": "Give your discussion a title…",
    "community.description": "Ask questions, share ideas and join the conversation. Anyone signed in can start a discussion.",
    "community.new": "Start a discussion",
    "community.empty": "No discussions yet. Start the first one.",
    "community.title": "Discussion title",
    "community.body": "What would you like to discuss?",
    "community.create": "Publish discussion",
    "community.save": "Save changes",
    "community.cancel": "Cancel",
    "community.edit": "Edit",
    "community.delete": "Delete",
    "community.deleteDiscussion": "Delete this discussion and its comments?",
    "community.deleteComment": "Delete this comment? Replies will be preserved.",
    "community.discard": "Discard unsaved changes?",
    "community.loading": "Loading…",
    "community.saving": "Saving…",
    "community.error": "This could not be completed. Please try again.",
    "community.sessionExpired": "Your session has expired. Sign in again and retry.",
    "community.forbidden": "You do not have access to this action.",
    "community.notFound": "This content is no longer available.",
    "community.invalid": "Check the text and try again.",
    "community.tooMany": "Too many requests. Wait a moment and try again.",
    "community.retry": "Try again",
    "community.login": "Sign in",
    "community.loginCreate": "Sign in to start a discussion.",
    "community.loginComment": "Sign in to comment and react.",
    "community.loginReact": "Sign in to add a reaction.",
    "community.anonymous": "User",
    "community.comments": "Comments",
    "community.commentCount": "Comments: {count}",
    "community.noComments": "No comments yet.",
    "community.commentLabel": "Write a comment",
    "community.sendComment": "Post comment",
    "community.reply": "Reply",
    "community.replyLabel": "Your reply",
    "community.sendReply": "Post reply",
    "community.replyTo": "Replying to {name}",
    "community.parentComment": "Parent comment",
    "community.deleted": "This comment was deleted.",
    "community.edited": "edited",
    "community.moreComments": "Load more comments",
    "community.reaction": "Reactions",
    "community.addReaction": "Add reaction",
    "community.reactionCount": "{emoji}: {count}",
    "community.reactionHint": "Choose a reaction. Select it again to remove it.",
    "community.previous": "Previous",
    "community.next": "Next",
    "community.page": "Page {page}",
    "community.pagination": "Discussion pagination",
    "community.back": "Back to discussions",
    "community.open": "Open discussion",
    "community.emptyPage": "There are no discussions on this page.",
    "community.closeComments": "Hide comments",
    "community.emoji.👍": "Like",
    "community.emoji.❤️": "Love",
    "community.emoji.😂": "Laugh",
    "community.emoji.🎉": "Celebrate",
    "community.emoji.😮": "Surprise",
    "community.emoji.🙏": "Thanks"
  }
} as const;
